export default {
  getReportings: state => state.reportings
}
